import type { CampaignTemplate } from '@/connection/campaigns/fetch-campaign-templates';
import { campaignTemplates } from '@/micros/edit-project/grid-areas/main/campaigns/templates';

export interface CampaignTemplatesState {
  templates: CampaignTemplate[];
  loadingTemplates: boolean;
  errorLoadingTemplates: boolean;
}

export const initialState: CampaignTemplatesState = {
  templates: campaignTemplates,
  loadingTemplates: false,
  errorLoadingTemplates: false,
};
